import styled from 'styled-components';
import { FormControl } from '@material-ui/core';

export const Wrapper = styled(FormControl)`
  .MuiInputLabel-outlined {
    transform: translate(14px, 11px) scale(1);
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75);
  }
`;
